var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"flex flex-row justify-center my-20"},[_c('img',{staticClass:"w-96",staticStyle:{"max-width":"90%"},attrs:{"alt":"404 image","src":require("@/assets/404.svg")}})])])
}]

export { render, staticRenderFns }